import CheckBox from './checkBox';
import Radio from './radio';
export { CheckBox, Radio };



//////////////////
// WEBPACK FOOTER
// ./src/detail/components/input/index.tsx
// module id = 226
// module chunks = 0